import TextField from '@mui/material/TextField';

const FromTextField =  ({
  label = "投入工場",
  helperText = "",
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfTounyuKojo"
    label={label}
    size="small"
    inputProps={{ maxLength: 3 }}
    onChange={(event: any) => { onChange(event); }}
    error={!!helperText}
    helperText={helperText}
  />
);

export default FromTextField;